module.exports = __webpack_public_path__ + "static/9-4f02cf4d21ccc94f94420d569cb82c23.jpg";